import { TypedModelCache } from './typed-model-cache';

export class ModelCache extends TypedModelCache<any> {}
